import { getState } from 'live/redux/selectors/index.shared';
import get from 'lodash/get';
import { createSelector } from 'reselect';

const getSelectedGameState = createSelector(getState, state =>
  get(state, 'selectedGame'),
);

export const getSelectedGame = createSelector(getSelectedGameState, state =>
  get(state, 'game'),
);

export const getSelectedGameLoading = createSelector(
  getSelectedGameState,
  state => get(state, 'loading'),
);

export const getSelectedGameError = createSelector(
  getSelectedGameState,
  state => get(state, 'error'),
);
